import { centsToDollars } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import RibbonIcon from "../RibbonIcon"

class DockwaPlusOffer extends React.Component {
  render() {
    const {
      dockwaPlusOffer,
      userId,
      loadingProductInformation,
      handleOpenModal,
    } = this.props

    const {
      original_amount: originalAmount,
      discounted_amount: discountedAmount,
      body,
    } = dockwaPlusOffer

    return (
      <div className="rounded-lg bg-gradient-to-r from-blue-100 to-blue-50 p-4 shadow-md">
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-2 text-blue-900">
            <RibbonIcon />
            <span className="text-base font-bold">Dockwa+ Price</span>
          </div>
          <div className="text-right text-base">
            <span className="mr-2 text-gray-500 line-through">
              {centsToDollars(originalAmount)}
            </span>
            <span className="font-semibold text-gray-900">
              {centsToDollars(discountedAmount)}
            </span>
          </div>
        </div>

        <p className="mb-4 text-gray-700">{body}</p>

        <button
          onClick={handleOpenModal}
          type="button"
          className="inline-flex items-center gap-2 bg-transparent p-0 font-semibold text-blue-800 no-underline hover:text-blue-700"
        >
          {userId
            ? "Learn more and sign up today"
            : "Log in to get started with Dockwa+"}
          {loadingProductInformation ? (
            <i className="fa-solid fa-spinner-third fa-spin h-full" />
          ) : (
            <i className="fa-solid fa-caret-right h-fell" />
          )}
        </button>
      </div>
    )
  }
}

DockwaPlusOffer.propTypes = {
  dockwaPlusOffer: PropTypes.shape({
    original_amount: PropTypes.number,
    discounted_amount: PropTypes.number,
    body: PropTypes.string,
  }).isRequired,
  userId: PropTypes.number,
  handleOpenModal: PropTypes.func.isRequired,
  loadingProductInformation: PropTypes.bool,
}

export default DockwaPlusOffer
